<template>
  <div>
    <!-- TOASTERS -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              TOASTERS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row class="mt-4">
              <div class="col-5">
                <b-alert variant="success"
                         show
                         dismissible
                >
                  <p>
                    <i class="icon icon-checkbox-selected" />
                    <span class="alert-content">Julian Bryan adlı aday
                      <b>'İkinci Listem'</b> listesine eklendi
                      <br>
                      <a class="alert-link"
                         href="href"
                      >link</a>
                    </span>
                  </p>
                </b-alert>
              </div>
              <div class="col-5">
                <b-alert variant="danger"
                         show
                         dismissible
                >
                  <p>
                    <i class="icon icon-warning" />
                    <span class="alert-content">Julian Bryan adlı aday
                      <b>'İkinci Listem'</b> listesine eklendi
                      <br>
                      <a class="alert-link"
                         href="href"
                      >link</a>
                    </span>
                  </p>
                </b-alert>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-5">
                <b-alert variant="warning"
                         show
                         dismissible
                >
                  <p>
                    <i class="icon icon-info" />
                    <span class="alert-content">Julian Bryan adlı aday
                      <b>'İkinci Listem'</b> listesine eklendi
                      <br>
                      <a class="alert-link"
                         href="href"
                      >link</a>
                    </span>
                  </p>
                </b-alert>
              </div>
              <div class="col-5">
                <b-alert variant="info"
                         show
                         dismissible
                >
                  <p>
                    <i class="icon icon-info" />
                    <span class="alert-content">Julian Bryan adlı aday
                      <b>'İkinci Listem'</b> listesine eklendi
                      <br>
                      <a class="alert-link"
                         href="href"
                      >link</a>
                    </span>
                  </p>
                </b-alert>
              </div>
            </b-row>
            <b-row>
              <div class="col-10">
                <p class="bold mt-4">
                  Warning
                </p>
                <p class="mt-3 mb-3">
                  Başlık alanının altına sabit olarak konulur ve uzunluğu tüm içerik kadardır.
                </p>
                <b-alert class="inline"
                         variant="warning"
                         show
                         dismissible
                >
                  <p>
                    <i class="icon icon-warning icon-20" />
                    <span class="alert-content">Julian Bryan adlı aday
                      <b>'İkinci Listem'</b> listesine eklendi
                      <a class="alert-link"
                         href="href"
                      >link</a>
                    </span>
                  </p>
                </b-alert>
                <button class="btn sm with-icon border-traid text-purple mt-2"
                        @click="showMessage()"
                >
                  Show Notification
                </button>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
import { showNotification } from '@/static/helpers/';

export default {
  name: 'Toaster',
  data() {
    return {};
  },
  mounted() {},
  methods: {
    showMessage() {
      showNotification(
        'Onay',
        'Julian Bryan adlı aday İkinci Listem listesine eklendi.',
        'success',
      );
      // showNotification(
      //   "Uyarı",
      //   "Julian Bryan adlı aday İkinci Listem listesine eklendi.",
      //   "warning"
      // );
      // showNotification(
      //   "Hata",
      //   "Julian Bryan adlı aday İkinci Listem listesine eklendi.",
      //   "error"
      // );
      // showNotification(
      //   "Bilgi",
      //   "Julian Bryan adlı aday İkinci Listem listesine eklendi.",
      //   "info"
      // );
    },
  },
};
</script>
